var Adapter = require('../adapter/adapter')
var NpawVideo = require('../video/video')

var PluginAdsMixin = {
  /**
   *
   * @param {object|string} player Either an instance of the player or a string containing an ID.
   * @param {string} adapterJsonCode
   * @param {object} options
   * @param {string} videoKey
   */
  registerAdsAdapter: function (player, adapterJsonCode, options, videoKey) {
    videoKey = videoKey || 'default'
    if (!this.videos.existsVideo(videoKey)) {
      // First, create new empty video object
      var videoObj = new NpawVideo(videoKey, this, this.options, null, null)
      videoObj.mergeOptions(options)
      this.videos.setVideo(videoObj)
      // Then, create adapter, and set adapter
      var adapter = new Adapter(videoKey, videoObj, this, this.adapterTemplates, player, adapterJsonCode)
      this.setAdsAdapter(adapter, videoKey)
    } else {
      this.videos.getVideo(videoKey).mergeOptions(options)
      this.setAdsAdapter(new Adapter(videoKey, this.videos.getVideo(videoKey), this, this.adapterTemplates, player, adapterJsonCode), videoKey)
    }
  },

  /**
     * Returns current adapter or null.
     *
     * @param {string} videoKey
     * @returns {Adapter}
     *
     * @memberof npaw.Plugin.prototype
     */
  getAdsAdapter: function (videoKey) {
    videoKey = videoKey || 'default'
    return this.videos.getVideo(videoKey).getAdsAdapter()
  },

  /**
     * Sets an adapter for ads.
     *
     * @param {Adapter} adsAdapter
     * @param {string} videoKey
     *
     * @memberof npaw.Plugin.prototype
     */
  setAdsAdapter: function (adsAdapter, videoKey) {
    videoKey = videoKey || 'default'
    this.videos.getVideo(videoKey).setAdsAdapter(adsAdapter, this)
  },

  /**
     * Removes the current adapter. Fires stop if needed. Calls adapter.dispose()
     *
     * @param {string} videoKey
     *
     * @memberof npaw.Plugin.prototype
     */
  removeAdsAdapter: function (videoKey) {
    videoKey = videoKey || 'default'
    this.videos.getVideo(videoKey).removeAdsAdapter()
  }
}

module.exports = PluginAdsMixin
